// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const RecordSchema = z.object({
    name: z.string().min(1, 'Required'),
    // Nullable AND optional: both are nullable in the API, and an untouched field arrives
    // undefined, which `.nullable()` alone rejects as "Required" (FNP-1897).
    category: z.string().nullable().optional(),
    description: z.string().nullable().optional(),
});
